import { BaseEntity } from "./base-entity.model";

import * as firebase from "firebase/app";
import "firebase/firestore";

export class AssignmentProposal extends BaseEntity {
  user: firebase.firestore.DocumentReference;
  cart: firebase.firestore.DocumentReference;
  itinerary: firebase.firestore.DocumentReference;
  proposalDate: firebase.firestore.Timestamp;
  answerDate: firebase.firestore.Timestamp;
  accepted: boolean;
  rejected: boolean;
  pending: boolean;
  answered: boolean;
  fee: number;
  test: boolean;
}
